export default __webpack_public_path__ + "static/media/bihorel13.57e2f23e.jpg";